var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{staticClass:"upload-btn",attrs:{"type":_vm.type,"loading":_vm.loading}},[_c('span',{staticClass:"upload-text"},[_vm._v(_vm._s(_vm.uploadText))]),_c('label',{staticClass:"upload-label",attrs:{"for":"name"}},[_c('input',{staticClass:"upload-input",attrs:{"type":"file","id":"name","accept":".xlsx,.xls"},on:{"input":_vm.selectFile}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }